import React, { useState, useRef, useEffect } from "react";
import BasicLayout from "../layouts/Basic";
import Responsive from "../layouts/Responsive";

import Title from "../components/Title";

import gsap from "gsap";

import E1 from "../assets/image/e1.png";
import E2 from "../assets/image/e2.png";
import E3 from "../assets/image/e3.png";

const gray = "#E4E4E7";
const pink = "#A51F7F";
const blue = "#83A9F4";
const night = "#191020";

const colors = [gray, blue, night, pink];
let currentColorIndex = 0;

const Pink = () => {
  const boxRef = useRef(null);

  const [skyColor, setSkyColor] = useState(gray);

  const handleChangeColor = () => {
    const currentColor = colors[currentColorIndex];
    gsap.to(boxRef.current, {
      backgroundColor: currentColor,
      duration: 0.2,
    });
    currentColorIndex = (currentColorIndex + 1) % colors.length;
  };

  const handleConfirm = () => {
    setSkyColor(boxRef.current.style.backgroundColor);
  };

  useEffect(() => {
    if (skyColor === "rgb(165, 31, 127)") {
      gsap.to(".section-1", {
        background: "linear-gradient(to bottom, #83a9f4, #a51f7f, #a51f7f)",
      });
      gsap.to(".row-1 .text-box", {
        opacity: 1,
        duration: 1,
        x: "random(0, 20)",
        y: "random(0, -100)",
        // repeat: -1,
        ease: "elastic",
        display: "block"
      });
      gsap.to(".row-2 .text-box", {
        opacity: 1,
        duration: 0.5,
        x: "random(0, 20)",
        y: "random(0, 100)",
        ease: "elastic",
        display: "block"
      });
    } else {
      gsap.to(".section-1", {
        background: skyColor,
      });
      gsap.to(".text-box", {
        opacity: 0,
        duration: 0.2,
      });
    }
  }, [skyColor]);

  return (
    <>
      <Responsive />
      <div className="scroll-wrapper">
        <div className="left-con">
          {/* <Title /> */}
          <div className="canvas-wrapper scroll-area">
            <div className="scroll">
              <div className="color-picker-wrapper">
                <div className="header">
                  <img src={E1} alt="esc" />
                  <img src={E2} alt="minimize" />
                  <img src={E3} alt="full screen" />
                </div>
                <div className="contents">
                  <div className="info-text">
                    <p>The color of the sky is.. </p>
                  </div>
                  <div className="color-box" ref={boxRef}></div>
                  <div className="button-box">
                    <button
                      type="button"
                      className="change"
                      onClick={handleChangeColor}
                    >
                      CHANGE THE COLOR
                    </button>
                    <button
                      type="button"
                      className="confirm"
                      onClick={handleConfirm}
                    >
                      CHANGE THE SKY COLOR
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="section section-1"
                style={{ backgroundColor: skyColor }}
              >
                <div className="row row-1">
                  <div className="text-box">
                    <p className="text">Then</p>
                  </div>
                  <div className="text-box">
                    <p className="text">he</p>
                  </div>
                  <div className="text-box">
                    <p className="text">became</p>
                  </div>
                  <div className="text-box">
                    <p className="text">pink</p>
                  </div>
                </div>
                <div className="row row-2">
                  <div className="text-box">
                    <p className="text">peacefully</p>
                  </div>
                  <div className="text-box">
                    <p className="text">the</p>
                  </div>
                  <div className="text-box">
                    <p className="text">sky</p>
                  </div>
                  <div className="text-box">
                    <p className="text">took</p>
                  </div>
                  <div className="text-box">
                    <p className="text">on</p>
                  </div>
                  <div className="text-box">
                    <p className="text">color</p>
                  </div>
                </div>
              </div>
              {/* <div className="section section-2"></div>
              <div className="section section-3"></div> */}
            </div>
          </div>
        </div>
        {/* </div> */}
        <BasicLayout />
      </div>
    </>
  );
};

export default Pink;
